import { io } from "socket.io-client";
import { getApiBaseUrl } from "config";

const socketIo = (string) => {
  const uri = getApiBaseUrl();
  return io(`${uri.slice(0, uri.length - 3)}${string}`, {
    transports: ["websocket"],
  });
};

export { socketIo };
